// client/src/utils/api/invites.js
import { api, handleRequestError } from "./config";

/**
 * Send a VIP invitation email.
 * Returns response.data per API helper standards.
 */
export const sendVipInvite = async (email, inviterFirstName) => {
  try {
    const response = await api.post("/invites/vip", {
      email,
      inviter_first_name: inviterFirstName,
    });
    return response.data;
  } catch (error) {
    return handleRequestError(error, "Failed to send VIP invite");
  }
};
